/* 
-----------------------------------------------------------------------------
| CALENDAR
-----------------------------------------------------------------------------
- description: simple calendar component with the basics of day cells 
  rendering. Wrap it in a bigger component to add more specific funcionalities.
*/
import { FC, HTMLAttributes } from "react";
import { getWeekSlotsTillMonthEnd } from "../../utils/helpers";
import { CalendarCells } from "./CalendarCells";
import { Dialog } from "../../components/dialog/Dialog";

export interface CalendarDateInfo {
    dateObject: Date
    isBeforeToday: boolean
    isBeforeMonthStart: boolean
    isAfterMonthEnd: boolean
    isInThisMonth: boolean
    isToday: boolean
    isWeekend: boolean
    isSelected: boolean
}
interface CalendarProps extends HTMLAttributes<HTMLDivElement> {
    date: Date
    allowPartialMonth?: boolean
    maxDisplayedWeeks?: number
    className: string
    value?: Date | number | string
    CellComponent: FC<{ dateInfo: CalendarDateInfo }>
    ControlsComponent?: FC
}

export const Calendar: FC<CalendarProps> = ({
    date, 
    value,
    allowPartialMonth, 
    maxDisplayedWeeks, 
    CellComponent, 
    ControlsComponent,
    className,
    ...rest
}) => {

    const DISPLAYED_WEEKS = getWeekSlotsTillMonthEnd(date)
    const VALUE = new Date((value ?? 'force_invalid_date'))

    return (
        <>
        <div className={`${className} p-r`} {...rest}>
            <Dialog id="calendar-dialog" availableDialogs={['loading']} />
            {ControlsComponent && (<ControlsComponent />)}
            <table 
                role="table"
            >
                <CalendarCells 
                    date={date} 
                    CellComponent={CellComponent} 
                    value={VALUE}
                />
            </table>
            {/* show the partial calendar */}
            {date.getDate() > 1 && allowPartialMonth && DISPLAYED_WEEKS < (maxDisplayedWeeks ?? 5) &&  (
                <table 
                    role="table"
                    aria-hidden
                >
                    <CalendarCells 
                        date={new Date(date.getFullYear(), date.getMonth() + 1, 1)} 
                        CellComponent={CellComponent} 
                        maxDisplayedWeeks={(maxDisplayedWeeks ?? 5) - DISPLAYED_WEEKS}
                        value={VALUE}
                    />
                </table>
            )}
        </div>
        </>
    )
}


